export default __webpack_public_path__ + "static/media/AnakAgungNgurahTemajaPutra.033b2efe.png";